export function accountTypeFromCode(code) {
    switch (code.trim()[0]) {
        case '1':
            return 'ASSET';
        case '2':
            return 'LIABILITY';
        case '3':
            return 'EQUITY';
        case '4':
            return 'REVENUE';
        case '5':
            return 'COST';
        case '6':
            return 'EXPENSE';
        default:
            throw new Error(`Cannot derive account type from code "${code}"`);
    }
}
// Semantic posting keys. FA_* and LEASE_* are sensible per-company DEFAULTS for
// fixed-asset / TFRS-16 lease postings; per-category overrides still live on
// AssetCategory rows.
export const ACCOUNT_KEYS = [
    'CASH_PETTY',
    'CASH_ON_HAND',
    'CASH_OVER_SHORT', // เงินสดขาด/เกินบัญชี — petty-cash count variance offset (M4b)
    'BANK_PRIMARY',
    'AR_TRADE',
    'AR_FOREIGN',
    'AP_TRADE',
    'AP_FOREIGN',
    'VAT_OUTPUT',
    'VAT_INPUT',
    'VAT_INPUT_SUSPENSE',
    'VAT_INPUT_PROHIBITED',
    'VAT_INPUT_EXPIRED',
    'WHT_PAYABLE',
    'WHT_PREPAID',
    'RETENTION_PAYABLE',
    'CUSTOMER_ADVANCE', // 20200002 รายได้รับล่วงหน้า — liability for customer deposits/advances (AR-12)
    'EMPLOYEE_ADVANCE',
    'PREPAID_ASSET',
    'INCOME_TAX_PAYABLE',
    'RETAINED_EARNINGS',
    'SALES_DOMESTIC',
    'SALES_EXPORT',
    'COGS',
    'GAIN_LOSS_DISPOSAL',
    'LVA_EXPENSE',
    'EMP_BENEFIT_EXPENSE',
    'EMP_BENEFIT_LIABILITY',
    'EMP_BENEFIT_REMEASUREMENT_OCI',
    'EMP_BENEFIT_SETTLEMENT_GAINLOSS',
    'ACCRUED_EXPENSE',
    'INTEREST_EXPENSE',
    'INTEREST_INCOME',
    'DISCOUNT_RECEIVED', // ส่วนลดรับ — early-payment (cash) discount income (AP Phase C1)
    'FX_GAIN_LOSS',
    'BANK_FEE',
    'PROPERTY_TAX_LAND_EXPENSE',
    'PROPERTY_TAX_SIGN_EXPENSE',
    'PROPERTY_TAX_LAND_ACCRUED',
    'PROPERTY_TAX_SIGN_ACCRUED',
    'CIP_ASSET',
    'CIP_CLEARING', // CIP-receipt clearing (AP bill work-cost → CIP register; Phase 4b; never a control account on manual JVs)
    'DEFERRED_TAX_EXPENSE',
    'MISC_EXPENSE',
    // Fixed-asset defaults (per-category overrides on AssetCategory rows win).
    'FA_COST',
    'FA_CLEARING', // asset-receipt clearing (bridge for JV/AP → register; never a control account)
    'FA_ACCUM_DEP',
    'FA_DEP_EXPENSE',
    'FA_DISPOSAL_GAIN_LOSS',
    // TFRS 16 lease set.
    'LEASE_ROU_ASSET',
    'LEASE_ACCUM_DEP',
    'LEASE_LIABILITY',
    'LEASE_INTEREST',
    'LEASE_DEP_EXPENSE',
    'LEASE_TERM_GAIN_LOSS',
];
// Default COA code mapped to the FA_CLEARING key (see ACCOUNT_MAPPING_DEFAULTS).
// Frontend convenience constant; the backend resolves FA_CLEARING per-company.
// If per-company overrides are ever introduced, replace frontend usages with a
// resolved value from an API.
export const FA_CLEARING_DEFAULT_CODE = '10190020';
//# sourceMappingURL=account-keys.js.map